"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7817],{

/***/ 7817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Vs": function() { return /* reexport */ CancelVisitConsultUsersReservationGateway; },
  "w_": function() { return /* reexport */ CreateQuickConsultGateway; },
  "zM": function() { return /* reexport */ CreateSeqConsultGateway; },
  "o3": function() { return /* reexport */ CreateVisitConsultRequestReservationGateway; },
  "dL": function() { return /* reexport */ GetConsultInfoGateway; },
  "S6": function() { return /* reexport */ GetConsultListGateway; },
  "lx": function() { return /* reexport */ GetQuickConsultBasicInfoGateway; },
  "k4": function() { return /* reexport */ GetQuickConsultChannelInfoGateway; },
  "UA": function() { return /* reexport */ GetQuickConsultDetailGateway; },
  "Sk": function() { return /* reexport */ GetVisitConsultBasicInfoGateway; },
  "_S": function() { return /* reexport */ GetVisitConsultChannelInfoGateway; },
  "Vu": function() { return /* reexport */ GetVisitConsultTimeCodeGateway; },
  "Dx": function() { return /* reexport */ GetVisitConsultUserInfoGateway; },
  "Bz": function() { return /* reexport */ GetVisitConsultUsersReservationGateway; },
  "aX": function() { return /* reexport */ SEQ_CONSULT_BANNER_CONFIG_KEY; },
  "B_": function() { return /* reexport */ UploadConsultTempImageGateway; },
  "ZF": function() { return /* reexport */ isRegularMember; },
  "mf": function() { return /* reexport */ resolveSeqConsultBannerPath; },
  "eo": function() { return /* reexport */ toSeqConsultBanners; },
  "BZ": function() { return /* reexport */ validateSeqConsultBannerConfig; }
});

// UNUSED EXPORTS: GetSharedUntactSuggestDetailGateway, GetVisitConsultItemCodeGateway, SEQ_CONSULT_BANNER_KEYS, hello, isExposedSeqConsultBanner, parseExposureDate

;// CONCATENATED MODULE: ../../shared/remodeling-manager/src/utils/consultMember.ts
/**
 * 시퀀셜 상담 회원 판정 — HSMALL-17244
 *
 * 정회원(한샘몰 일반 가입, simpleUserFlag 'N')만 true.
 * 간편회원(소셜/애플, 'Y')·비회원·회원정보 미로드(undefined)는 모두 false →
 * 이름·번호 직접 입력 + 휴대폰 점유인증 대상.
 * 로그인 여부(isAuthenticated)로 면제를 가르던 기존 분기를 대체한다.
 * (TS-001~004)
 */ var isRegularMember = function(userInfo) {
    return (userInfo === null || userInfo === void 0 ? void 0 : userInfo.simpleUserFlag) === "N";
};

;// CONCATENATED MODULE: ../../shared/remodeling-manager/src/utils/seqConsultBanner.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
/** 리모트 컨피그(display-service /api/v1/configs/{key}) 조회 키 */ var SEQ_CONSULT_BANNER_CONFIG_KEY = "seq-consult";
/** 화면이 지원하는 배너 슬롯 — 운영 데이터 화이트리스트 */ var SEQ_CONSULT_BANNER_KEYS = [
    "STEP_FIRST",
    "STEP_SECOND",
    "PERSONAL_TOP",
    "EXIT_POPUP",
    "FINISH", 
];
/**
 * 노출 일시 파싱 — HSMALL-17376
 *
 * `new Date(string)` 은 ISO 8601 형식만 동작이 스펙으로 보장된다. 그 외 포맷은
 * 브라우저마다 결과가 달라 운영자가 넣은 값이 특정 브라우저에서만 Invalid Date 가
 * 되는 사고가 난다. 그래서 형식을 먼저 검사하고, 통과한 값만 Date 로 만든다.
 *
 * 'YYYY-MM-DD HH:mm:ss'(공백 구분)은 실수로 자주 들어오는 형태라 T 로 정규화해 받되,
 * validateSeqConsultBannerConfig 가 NON_ISO_EXPOSURE_DATE 로 보고한다.
 * 오프셋이 없으면 사용자 기기 로컬 타임존으로 해석되므로 '+09:00' 명시를 권장한다.
 */ var EXPOSURE_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}(:\d{2})?(\.\d+)?(Z|[+-]\d{2}:?\d{2})?$/;
var parseExposureDate = function(value) {
    var trimmed = value === null || value === void 0 ? void 0 : value.trim();
    if (!trimmed || !EXPOSURE_DATE_PATTERN.test(trimmed)) {
        return null;
    }
    // '2026-02-30' 같은 달력에 없는 날짜는 Invalid Date 가 아니라 다음 달로 넘어간다.
    // 운영자가 의도하지 않은 날짜로 조용히 노출되는 것을 막기 위해 직접 검사한다.
    var ref = _slicedToArray(trimmed.slice(0, 10).split("-").map(Number), 3), year = ref[0], month = ref[1], day = ref[2];
    var calendar = new Date(Date.UTC(year, month - 1, day));
    if (calendar.getUTCFullYear() !== year || calendar.getUTCMonth() !== month - 1 || calendar.getUTCDate() !== day) {
        return null;
    }
    var parsed = new Date(trimmed.replace(" ", "T"));
    return Number.isNaN(parsed.getTime()) ? null : parsed;
};
/**
 * 리모트 컨피그 value → 채널별 배너 목록 — HSMALL-17376
 *
 * 다음 항목은 버린다.
 * - 화이트리스트에 없는 bannerKey (운영 데이터 오타)
 * - 해당 채널 이미지 경로가 없는(null/공백) 항목 — EXIT_POPUP 처럼 한쪽 채널만
 *   운영하는 슬롯이 반대 채널에서 빈 이미지로 뜨는 것을 막는다.
 *
 * 미등록 key(data:null)·조회 실패·형태 불일치는 모두 빈 배열 → 화면은 기본 이미지를 쓴다.
 * 버려진 항목의 사유는 validateSeqConsultBannerConfig 로 확인한다.
 */ var toSeqConsultBanners = function(config, channel) {
    if (!Array.isArray(config)) {
        return [];
    }
    return config.reduce(function(acc, item) {
        var ref;
        var imageUrl = (ref = channel === "PC" ? item === null || item === void 0 ? void 0 : item.pcImageUrl : item === null || item === void 0 ? void 0 : item.moImageUrl) === null || ref === void 0 ? void 0 : ref.trim();
        if (!SEQ_CONSULT_BANNER_KEYS.includes(item === null || item === void 0 ? void 0 : item.bannerKey) || !imageUrl) {
            return acc;
        }
        acc.push({
            bannerKey: item.bannerKey,
            imageUrl: imageUrl,
            exposureStartAt: item.exposureStartAt,
            exposureEndAt: item.exposureEndAt
        });
        return acc;
    }, []);
};
/**
 * 운영 데이터 점검 — HSMALL-17376
 *
 * 폴백이 잘 되는 만큼 잘못된 설정이 장애로 드러나지 않는다(배너가 조용히 안 바뀐다).
 * 호출부에서 이 결과를 로깅해 원인을 남긴다.
 *
 * 채널별 이미지 누락은 정상 운영(한쪽 채널만 노출)과 구분이 안 되므로 여기서 보지 않는다.
 */ var validateSeqConsultBannerConfig = function(config) {
    if (!Array.isArray(config)) {
        return [];
    }
    return config.reduce(function(acc, item, index) {
        if (!SEQ_CONSULT_BANNER_KEYS.includes(item === null || item === void 0 ? void 0 : item.bannerKey)) {
            acc.push({
                index: index,
                bannerKey: item === null || item === void 0 ? void 0 : item.bannerKey,
                reason: "UNKNOWN_BANNER_KEY"
            });
            return acc;
        }
        var fields = [
            "exposureStartAt",
            "exposureEndAt"
        ];
        fields.forEach(function(field) {
            var raw = item === null || item === void 0 ? void 0 : item[field];
            if (!raw) {
                return;
            }
            if (!parseExposureDate(raw)) {
                acc.push({
                    index: index,
                    bannerKey: item.bannerKey,
                    reason: "INVALID_EXPOSURE_DATE",
                    field: field
                });
                return;
            }
            if (raw.includes(" ") || !/(Z|[+-]\d{2}:?\d{2})$/.test(raw.trim())) {
                acc.push({
                    index: index,
                    bannerKey: item.bannerKey,
                    reason: "NON_ISO_EXPOSURE_DATE",
                    field: field
                });
            }
        });
        var startAt = parseExposureDate(item === null || item === void 0 ? void 0 : item.exposureStartAt);
        var endAt = parseExposureDate(item === null || item === void 0 ? void 0 : item.exposureEndAt);
        if (startAt && endAt && startAt.getTime() > endAt.getTime()) {
            acc.push({
                index: index,
                bannerKey: item.bannerKey,
                reason: "INVERTED_EXPOSURE_PERIOD"
            });
        }
        return acc;
    }, []);
};
/**
 * 배너가 지금 노출 기간에 걸려 있는지 판정 — HSMALL-17376
 *
 * - 시작/종료 일시는 없으면 각각 하한/상한 없음으로 본다.
 * - 파싱 불가한 일시는 fail-closed(미노출) — 잘못된 운영 데이터로
 *   의도치 않은 이미지가 상시 노출되는 쪽이 더 위험하다.
 *   (조용히 묻히지 않도록 validateSeqConsultBannerConfig 로 보고한다)
 * - 경계값(시작·종료 시각 정각)은 노출에 포함한다.
 */ var isExposedSeqConsultBanner = function(banner) {
    var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Date();
    var current = now.getTime();
    if (Number.isNaN(current)) {
        return false;
    }
    if (banner.exposureStartAt) {
        var startAt = parseExposureDate(banner.exposureStartAt);
        if (!startAt || current < startAt.getTime()) {
            return false;
        }
    }
    if (banner.exposureEndAt) {
        var endAt = parseExposureDate(banner.exposureEndAt);
        if (!endAt || current > endAt.getTime()) {
            return false;
        }
    }
    return true;
};
/**
 * 배너 슬롯의 최종 이미지 경로 결정 — HSMALL-17376
 *
 * API 가 내려준 배너 중 해당 슬롯 + 노출 기간을 만족하는 첫 건을 쓰고,
 * 그 외(미응답 / 슬롯 없음 / 기간 미해당 / 빈 값)는 전부 defaultPath 로 폴백한다.
 * 기간이 겹치는 항목이 여럿이면 배열의 앞선 항목이 이긴다.
 *
 * 반환값은 CDN 루트 기준 상대 경로 — 환경별 도메인은 호출부에서 getCDNAsset 으로 붙인다.
 *
 * @param banners API 응답 배너 목록 (미로드 시 undefined)
 * @param bannerKey 배너 슬롯 키
 * @param defaultPath 현재 코드에 적용된 기본 이미지 경로
 */ var resolveSeqConsultBannerPath = function(banners, bannerKey, defaultPath) {
    var now = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : new Date();
    var ref;
    var exposed = banners === null || banners === void 0 ? void 0 : banners.find(function(banner) {
        var ref;
        return (banner === null || banner === void 0 ? void 0 : banner.bannerKey) === bannerKey && !!(banner === null || banner === void 0 ? void 0 : (ref = banner.imageUrl) === null || ref === void 0 ? void 0 : ref.trim()) && isExposedSeqConsultBanner(banner, now);
    });
    return (exposed === null || exposed === void 0 ? void 0 : (ref = exposed.imageUrl) === null || ref === void 0 ? void 0 : ref.trim()) || defaultPath;
};

;// CONCATENATED MODULE: ../../shared/remodeling-manager/src/utils/index.ts
var hello = function() {
    return "hello";
};



// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-769137b2ab/0/cache/next-npm-12.2.3-07d597c2b7-b13b42fbb3.zip/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(1861);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
;// CONCATENATED MODULE: ../../shared/remodeling-manager/src/adapter/gateway/untact-suggest.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var GetSharedUntactSuggestDetailGateway = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    "use strict";
    function GetSharedUntactSuggestDetailGateway(httpClient) {
        _classCallCheck(this, GetSharedUntactSuggestDetailGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetSharedUntactSuggestDetailGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/remodeling-manager-service/api/v1/shared/untact/").concat(req.randomPath)
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetSharedUntactSuggestDetailGateway;
}()));

;// CONCATENATED MODULE: ../../shared/remodeling-manager/src/adapter/gateway/quick-consult.ts
function quick_consult_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function quick_consult_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                quick_consult_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                quick_consult_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function quick_consult_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var GetQuickConsultChannelInfoGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetQuickConsultChannelInfoGateway(httpClient) {
        quick_consult_classCallCheck(this, GetQuickConsultChannelInfoGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetQuickConsultChannelInfoGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return quick_consult_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/remodeling-manager-service/api/v1/consults/base/channel"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetQuickConsultChannelInfoGateway;
}();
var GetQuickConsultBasicInfoGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetQuickConsultBasicInfoGateway(httpClient) {
        quick_consult_classCallCheck(this, GetQuickConsultBasicInfoGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetQuickConsultBasicInfoGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return quick_consult_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/remodeling-manager-service/api/v1/consults/info"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetQuickConsultBasicInfoGateway;
}();
var CreateQuickConsultGateway = /*#__PURE__*/ function() {
    "use strict";
    function CreateQuickConsultGateway(httpClient) {
        quick_consult_classCallCheck(this, CreateQuickConsultGateway);
        this.httpClient = httpClient;
    }
    var _proto = CreateQuickConsultGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return quick_consult_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "POST",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/remodeling-manager-service/api/v1/consults/base"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return CreateQuickConsultGateway;
}();
var GetQuickConsultDetailGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetQuickConsultDetailGateway(httpClient) {
        quick_consult_classCallCheck(this, GetQuickConsultDetailGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetQuickConsultDetailGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return quick_consult_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/remodeling-manager-service/api/v1/consults/").concat(req.id, "/base")
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetQuickConsultDetailGateway;
}();

;// CONCATENATED MODULE: ../../shared/remodeling-manager/src/adapter/gateway/consult.ts
function consult_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function consult_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                consult_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                consult_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function consult_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var GetConsultListGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetConsultListGateway(httpClient) {
        consult_classCallCheck(this, GetConsultListGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetConsultListGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return consult_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/remodeling-manager-service/api/v1/manager/").concat(req.userId),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetConsultListGateway;
}();
var UploadConsultTempImageGateway = /*#__PURE__*/ function() {
    "use strict";
    function UploadConsultTempImageGateway(httpClient) {
        consult_classCallCheck(this, UploadConsultTempImageGateway);
        this.httpClient = httpClient;
    }
    var _proto = UploadConsultTempImageGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return consult_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "POST",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/remodeling-manager-service/api/v1/consults/temp/image"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return UploadConsultTempImageGateway;
}();
var GetConsultInfoGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetConsultInfoGateway(httpClient) {
        consult_classCallCheck(this, GetConsultInfoGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetConsultInfoGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return consult_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/remodeling-manager-service/api/v1/consults/info"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetConsultInfoGateway;
}();

;// CONCATENATED MODULE: ../../shared/remodeling-manager/src/adapter/gateway/visit-consult.ts
function visit_consult_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function visit_consult_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                visit_consult_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                visit_consult_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function visit_consult_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var CreateVisitConsultRequestReservationGateway = /*#__PURE__*/ function() {
    "use strict";
    function CreateVisitConsultRequestReservationGateway(httpClient) {
        visit_consult_classCallCheck(this, CreateVisitConsultRequestReservationGateway);
        this.httpClient = httpClient;
    }
    var _proto = CreateVisitConsultRequestReservationGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return visit_consult_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "POST",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/remodeling-manager-service/api/v1/visit-consults/reservation"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return CreateVisitConsultRequestReservationGateway;
}();
var GetVisitConsultItemCodeGateway = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    "use strict";
    function GetVisitConsultItemCodeGateway(httpClient) {
        visit_consult_classCallCheck(this, GetVisitConsultItemCodeGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetVisitConsultItemCodeGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return visit_consult_asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/remodeling-manager-service/api/v1/visit-consults/reservation/item-code/").concat(req.shopId)
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetVisitConsultItemCodeGateway;
}()));
var GetVisitConsultTimeCodeGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetVisitConsultTimeCodeGateway(httpClient) {
        visit_consult_classCallCheck(this, GetVisitConsultTimeCodeGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetVisitConsultTimeCodeGateway.prototype;
    _proto.exec = function exec() {
        var _this = this;
        return visit_consult_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/remodeling-manager-service/api/v1/visit-consults/reservation/time-code")
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetVisitConsultTimeCodeGateway;
}();
var GetVisitConsultUserInfoGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetVisitConsultUserInfoGateway(httpClient) {
        visit_consult_classCallCheck(this, GetVisitConsultUserInfoGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetVisitConsultUserInfoGateway.prototype;
    _proto.exec = function exec() {
        var _this = this;
        return visit_consult_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/remodeling-manager-service/api/v1/visit-consults/user-info")
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetVisitConsultUserInfoGateway;
}();
var GetVisitConsultUsersReservationGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetVisitConsultUsersReservationGateway(httpClient) {
        visit_consult_classCallCheck(this, GetVisitConsultUsersReservationGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetVisitConsultUsersReservationGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return visit_consult_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/remodeling-manager-service/api/v1/visit-consults/reservation"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetVisitConsultUsersReservationGateway;
}();
var CancelVisitConsultUsersReservationGateway = /*#__PURE__*/ function() {
    "use strict";
    function CancelVisitConsultUsersReservationGateway(httpClient) {
        visit_consult_classCallCheck(this, CancelVisitConsultUsersReservationGateway);
        this.httpClient = httpClient;
    }
    var _proto = CancelVisitConsultUsersReservationGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return visit_consult_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "DELETE",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/remodeling-manager-service/api/v1/visit-consults/").concat(req.visitConsultId, "/reservation")
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return CancelVisitConsultUsersReservationGateway;
}();
var GetVisitConsultChannelInfoGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetVisitConsultChannelInfoGateway(httpClient) {
        visit_consult_classCallCheck(this, GetVisitConsultChannelInfoGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetVisitConsultChannelInfoGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return visit_consult_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/remodeling-manager-service/api/v1/consults/base/channel"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetVisitConsultChannelInfoGateway;
}();
var GetVisitConsultBasicInfoGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetVisitConsultBasicInfoGateway(httpClient) {
        visit_consult_classCallCheck(this, GetVisitConsultBasicInfoGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetVisitConsultBasicInfoGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return visit_consult_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/remodeling-manager-service/api/v1/consults/info"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetVisitConsultBasicInfoGateway;
}();

;// CONCATENATED MODULE: ../../shared/remodeling-manager/src/adapter/gateway/seq-consult.ts
function seq_consult_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function seq_consult_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                seq_consult_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                seq_consult_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function seq_consult_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var CreateSeqConsultGateway = /*#__PURE__*/ function() {
    "use strict";
    function CreateSeqConsultGateway(httpClient) {
        seq_consult_classCallCheck(this, CreateSeqConsultGateway);
        this.httpClient = httpClient;
    }
    var _proto = CreateSeqConsultGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return seq_consult_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "POST",
                            url: "".concat("https://gateway.hanssem.com").concat("/hanssem", "/remodeling-manager-service/api/v1/consults/base"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return CreateSeqConsultGateway;
}();

;// CONCATENATED MODULE: ../../shared/remodeling-manager/src/adapter/gateway/index.ts






;// CONCATENATED MODULE: ../../shared/remodeling-manager/src/adapter/index.ts


;// CONCATENATED MODULE: ../../shared/remodeling-manager/src/index.ts





/***/ })

}]);